import { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { updateContent } from 'store/content'
import { selectService } from 'store/selectedService'

class Home extends Component {
  componentDidMount () {
    this.props.updateContent({ type: 'homepage', items: [], 'title': '' })
    this.props.selectService(null)
  }

  render () {
    return null
  }
}

const mapDispatchToProps = {
  updateContent: (content) => updateContent(content),
  selectService: (serviceID) => selectService(serviceID),
}

Home.propTypes = {
  updateContent: PropTypes.func,
  selectService: PropTypes.func
}

export default connect(null, mapDispatchToProps)(Home)



// WEBPACK FOOTER //
// ./src/routes/Home/index.js